export default __webpack_public_path__ + "static/media/Link1.061291f8.svg";